import {vidyoProviderLogs} from '@/utils/general';

import {deviceListenerCb} from './utils/deviceListenerCb';

declare global {
    interface Window {
        vidyoConnector: any;
        microphone: any;
    }
}

type Props = {
    onAdded?: (localMicrophone: {id: string; name: string}) => void;
    onRemoved?: (localMicrophoneId: string) => void;
    setCurMic?: (mic: any) => void;
};

export const registerMicrophone = async (props?: Props) => {
    const {onAdded, onRemoved, setCurMic} = props || {};
    window['microphone'] = [];

    try {
        await window.vidyoConnector.RegisterLocalMicrophoneEventListener(
            deviceListenerCb({onAdded, onRemoved, setCurDevice: setCurMic, deviceName: 'microphone'}),
        );
        vidyoProviderLogs({
            message: 'LocalMicrophoneEventListener registered',
            eventType: 'device',
            status: 'success',
        });
    } catch (error) {
        vidyoProviderLogs({
            message: 'RegisterLocalMicrophoneEventListener failed: ' + error,
            eventType: 'device',
            status: 'error',
        });
    }
};
